
type ListItem<T> = {
  [K in keyof T]: {
    readonly key: string;
    readonly value: T[K];
  }
}[keyof T];

/**
* Helper to produce an array of enum descriptors.
* @param enumeration Enumeration object.
* @param separatorRegex Regex that would catch the separator in your enum key.
*/
export function enumToList<T extends Record<string, number | string>>(enumeration: T, separatorRegex: RegExp = /_/g): ListItem<T>[] {
  const array: Array<keyof T> = Object.keys(enumeration);
  return array
    .filter(key => isNaN(Number(key)))
    .filter(key => typeof enumeration[key] === 'number' || typeof enumeration[key] === 'string')
    .map(key => ({
      key: String(key).replace(separatorRegex, ' '),
      value: enumeration[key],
    }));
}

/**
 * Example
 *
 * enum viewModes {
 *   List = 0,
 *   Tree = 1,
 * }
 *
 * const modes = enumToList(viewModes);
 *
 */
